import React, { useEffect, useState } from 'react';

let enqueueToast = null;

export const toast = {
  success(message) {
    if (enqueueToast) enqueueToast({ id: Date.now() + Math.random(), type: 'success', message });
  },
  error(message) {
    if (enqueueToast) enqueueToast({ id: Date.now() + Math.random(), type: 'error', message });
  },
  info(message) {
    if (enqueueToast) enqueueToast({ id: Date.now() + Math.random(), type: 'info', message });
  }
};

export default function Toaster() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    enqueueToast = (t) => {
      setToasts(prev => [...prev, t]);
      setTimeout(() => {
        setToasts(prev => prev.filter(x => x.id !== t.id));
      }, 3000);
    };
    return () => { enqueueToast = null; };
  }, []);

  const baseStyle = {
    position: 'fixed',
    top: '16px',
    right: '16px',
    zIndex: 1080,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  };

  const itemStyle = (type) => ({
    minWidth: '260px',
    maxWidth: '420px',
    color: '#fff',
    borderRadius: '6px',
    boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
    padding: '10px 14px',
    background: type === 'success' ? '#28a745' : type === 'error' ? '#dc3545' : '#0d6efd'
  });

  return (
    <div style={baseStyle} aria-live="polite" aria-atomic="true">
      {toasts.map(t => (
        <div key={t.id} style={itemStyle(t.type)}>
          {t.message}
        </div>
      ))}
    </div>
  );
}


